function parseBooleanEnv(value: string | undefined, defaultValue: boolean) {
  if (typeof value !== 'string') return defaultValue
  const normalized = value.trim().toLowerCase()
  if (normalized === 'true') return true
  if (normalized === 'false') return false
  return defaultValue
}

export const featureFlags = {
  enableAdvisoryAIMenu: parseBooleanEnv(import.meta.env['VITE_ENABLE_ADVISORY_AI_MENU'], true),
  enableBasMenu: parseBooleanEnv(import.meta.env['VITE_ENABLE_BAS_MENU'], true),
}
